import {post, get} from '@/utils/request'

// 获取产品列表
export function getProductListReq(data) {
    return post({
        data,
        url: 'resource/core-product/list'
    })
}

// 获取业务类型
export function getBusiReq(data) {
    return post({
        data,
        url: 'resource/sys-pa-code/getCodes'
    })
}

// 改变上下架状态
export function changeSaleStatus(data) {
    return post({
        data,
        url: 'resource/core-product/changeSaleStatus'
    })
}

// 改变产品状态
export function changeStatus(data) {
    return post({
        data,
        url: 'resource/core-product/changeStatus'
    })
}

// 获取引入会员
export function getDevMemberReq(data) {
    return post({
        data,
        loading: false,
        url: 'resource/core-product/memberList'
    })
}

// 获取产品接口
export function getProductApiReq(data) {
    return post({
        data: {table: "CORE_PRODUCT", field: "INTERFACE"},
        url: 'resource/sys-pa-code/getCodes'
    })
}

// 根据id获取产品信息(编辑回显)
export function getProductInfoByIdReq(data) {
    return post({
        data,
        url: 'resource/core-product/detail'
    })
}

// 添加编辑产品
export function addOrAlterProductReq(data) {
    return post({
        data,
        url: 'resource/core-product/addOrAlter'
    })
}

  